import React, { ReactNode } from "react";

type Props = {
  children: ReactNode;
  title: string;
  subtitle: string;
};

const CarouselWrapper = (props: Props) => {
  const { title, subtitle, children } = props;
  return (
    <div className="sm:px-4 border-none bg-transparent">
      <div className="bg-gray-50 sm:rounded-3xl flex flex-col gap-6 pt-6 sm:py-6 overflow-hidden">
        <div className="flex flex-col gap-1 px-6 sm:px-4">
          <p className="text-xl font-medium">{title}</p>
          <p className="text-gray-600 leading-5 text-sm">{subtitle}</p>
        </div>
        {children}
      </div>
    </div>
  );
};

export default CarouselWrapper;
